import { render } from "./BoardDetailView.vue?vue&type=template&id=f3ff239a"
import script from "./BoardDetailView.vue?vue&type=script&lang=js"
export * from "./BoardDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/hpgdata/workspace/medicollege_front_prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__